export const ApiConstants = {
    Login: '/auth/sign-in',
    Logout: '/auth/logout',
    SignUp: '/auth/sign-up',
    VerifyOtp: '/auth/verify-otp',
    ResendOtp: '/auth/resend-otp',
    ForgotPassword: '/auth/forgot-password',
    ResetPassword: '/auth/reset-password',
    Profile: '/auth/profile',
    UpdateProfile: '/auth/update-profile',
    DoNOTSaleMyPersonalInfo: '/privacy/create',
    ChangePassword: '/auth/change-password',
    ContactUs: '/auth/contact-us',
    DeleteAccount: '/auth/delete-account',

    GetUsers: '/users/get',
    UserStatus: '/users/status',
    UserView: '/users/detail',
    GetDownload: '/auth/get-download',

    AddUser: '/users/create',


    CategoriesList: "categories/get",
    CategoriesStatus: "categories/status",
    CategoriesAdd: "categories/create",
    CategoriesEdit: "categories/update",
    CategoriesDetails: "categories/detail",

    CmsPagesDetail: "cms-pages/detail",

    FaqGet: "/faqs/get",


    Addhousehold: "/household/create",
    DeleteHouse: "/household/delete",
    RemoveHouseholdMember: "/household/remove-member",
    UpdateHousehold: "/household/update",
    GetHousehold: "/household/get",
    checkHousehold: "/household/check",
    inviteHousehold: "/household/invite",
    isCurrentUserExist: "/household/user-exists",
    updateMemberHousehold: "/household/update-member",
    GetHouseholdMembers: "/household/members",
    GetHouseholdDetails: "/household/detail",
    HouseholdSendCredential: "/household/send-credential",
    HouseholdSendInvitation: "/household/send-invitation",
    HouseholdCheckInvitation: "/household/check-invitation",
    HouseholdAcceptRejectInvitation: "/household/accept-reject-invitation",
    LeaveHousehold: "/household/leave-user",

    SubscriptionGetPlans: '/user-subs/get-plans',
    SubscriptionCheckout: '/user-subs/create-checkout-session',
    CurrentPlan: '/user-subs/current-plan',
    CancelSubscription: '/user-subs/cancel-subscription',
    CreateSubscriptionIntent: '/user-subs/create-subscription-intent',
    ChoresCategories: '/chores/categories',
    ChoresCreate: '/chores/create',
    ChoresGet: '/chores/get',
    ChoresUpdate: '/chores/update',
    AllChoresUpdate: '/chores/bulk-update',
    ChoresMarkAsComplete: '/chores/mark-as-complete',

    LocationGet: '/loc-manag/get',

    ExpensesCategoriesGet: '/expenses/categories',
    ExpensesCreate: '/expenses/create',
    ExpensesGet: '/expenses/get',
    ExpensesUpdate: '/expenses/update',
    AllExpenseUpdate: '/expenses/bulk-update',

    DashboardSummaryGet: '/contributions/get_dashboard_summary',
    ContributionsGet: '/contributions/get',
    ContributionsReports: '/contributions/reports',
    ContributionsCheck: '/contributions/check',
    HouseholdMemberAvailabilityCheck: '/household/member-exist-or-not',
    OppertunityCostCheck: '/opportunity-cost/get',
    OppertunityCostClaimeHours: '/opportunity-cost/claim-hourse',
    DeleteDeletedMemberChoresAndExpense: '/contributions/delete_orphaned_data',


    GetDashboard: "/dashboard/get",
    ChoresGraph: "/dashboard/chores-graph",
    ExpensesGraph: "/dashboard/expenses-graph",

    Notification: "/notification/get-all",
    NotificationRemove: "/notification/remove",
    UpdateNotificationSetting: "/notification/create-preferences",
    GetNotificationSetting: "/notification/get-preferences",

    UnAssignedExpenses: "/expenses/get-categorywise-expenses",
    markAsPaidExpenses: "/expenses/mark-as-paid",
    manualPayment: "/payment/manual-payment",
    transactionList: "/transaction/list",
    deleteTransaction: "/transaction/delete",
    deleteAllTransaction: "/transaction/bulk-delete",
    updateTransaction: "/transaction/update",
    allUpdateTransaction: "/transaction/bulk-update",
    paymentSummary: "/payment/summary",

    getPaymentMethod: "/payment/get-payment-methods",
    savePaymentMethod: "/payment/save-payment-method",
    getPaymentMethodLinks: "/payment/get-payment-method-details",
    deletePaymentMethodLinks: "/payment/delete-payment-method",

    sendReminder: "/payment/send-reminder",
    sendExpenseReminder: "/expenses/expense-reminder",
    sendChoreReminder: "/chores/chores-reminder",
}
